import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import catchErrors from 'utils/commands/catchErrors';
import { pushToast } from 'containers/ToastManager/actions';

import messages from '../messages';
import * as constants from '../constants';
import { commandIamTeamList } from '../actions';

export function* sendRequest(connection, action) {
  const { team: teamData, meta } = action;

  const workspaceTeamsCreate = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_IAM_TEAM_CREATE,
    name: teamData.name,
    description: teamData.description,
  });

  if (workspaceTeamsCreate.type === constants.RTM_IAM_TEAM_CREATE_OK) {
    yield put(commandIamTeamList());
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedIamTeamCreate} />,
      })
    );
  }

  if (meta && Array.isArray(meta.callbacks)) {
    meta.callbacks.forEach((callback) => callback());
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_TEAM_CREATE, catchErrors, sendRequest, connection);
}
